import { useMemo } from "react";
import { Recommendation } from "../chat/Recommendations";

export default function MarkdownBookRecommandation({ metadata, code }) {
    const book = useMemo(() => metadata?.recommendations?.find(el => el.code === code), [code, metadata?.recommendations])

    return <>
        {book && <Recommendation recommendation={book} />}
    </>
}